import { render, staticRenderFns } from "./TopicShow.vue?vue&type=template&id=1894a3db&"
import script from "./TopicShow.vue?vue&type=script&lang=js&"
export * from "./TopicShow.vue?vue&type=script&lang=js&"
import style0 from "./TopicShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports